module.exports = __webpack_public_path__ + "static/coach-hire-services-funerals-9afcc5f80f8d8587dc5db3cc92d45e35.jpg";